"use strict";
// import { SearchSelections } from "./types";
Object.defineProperty(exports, "__esModule", { value: true });
exports.onSearch = exports.setSearchBoxValue = exports.setSelectedLanguages = void 0;
// Define the action types as constants
const PREFIX = "translation-search/";
const SET_SELECTED_LANGUAGES_ACTION_TYPE = `${PREFIX}SET_SELECTED_LANGUAGES`;
const SET_SEARCH_BOX_VALUE_ACTION_TYPE = `${PREFIX}SET_SEARCH_BOX_VALUE`;
const ON_SEARCH_ACTION_TYPE = `${PREFIX}ON_SEARCH`;
// Utility function to create action creators
function createAction(type) {
    return (payload) => (Object.assign({ type }, payload));
}
// Create action creators using the utility function
exports.setSelectedLanguages = createAction(SET_SELECTED_LANGUAGES_ACTION_TYPE);
exports.setSearchBoxValue = createAction(SET_SEARCH_BOX_VALUE_ACTION_TYPE);
exports.onSearch = createAction(ON_SEARCH_ACTION_TYPE);
//# sourceMappingURL=actions.js.map